import android from './Android'
import apple from './Apple'
import facebook from './Facebook'
import github from './Github'
import google from './Google'
import instagram from './Instagram'
import linkedin from './Linkedin'
import medium from './Medium'
import pinterest from './Pinterest'
import reddit from './Reddit'
import skype from './Skype'
import snapchat from './Snapchat'
import tiktok from './Tiktok'
import twitter from './Twitter'
import vimeo from './Vimeo'
import whatsapp from './Whatsapp'
import wordpress from './Wordpress'
import youtube from './Youtube'

export {
  android,
  apple,
  facebook,
  github,
  google,
  instagram,
  linkedin,
  medium,
  pinterest,
  reddit,
  skype,
  snapchat,
  tiktok,
  twitter,
  vimeo,
  whatsapp,
  wordpress,
  youtube
}
